import { render, staticRenderFns } from "./StatsTab.vue?vue&type=template&id=18dfe6ff&scoped=true&"
import script from "./StatsTab.vue?vue&type=script&lang=js&"
export * from "./StatsTab.vue?vue&type=script&lang=js&"
import style0 from "./StatsTab.vue?vue&type=style&index=0&id=18dfe6ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18dfe6ff",
  null
  
)

export default component.exports